import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString } from "./fulfillment-group-csv-utils";

const customDateKeys = [
  "customDate1",
  "customDate2",
  "customDate3",
  "customAttributeDate1",
  "customAttributeDate2",
  "customAttributeDate3",
] as const;

export function getCustomDateCsvColumn(
  title: string,
  key: (typeof customDateKeys)[number],
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: title,
    cell: (row: FulfillmentGroupData) =>
      row[key]
        ? row[key]
            .map((date: Date) => formatDateString(date.toISOString(), true))
            .join(", ")
        : "",
  };
}
